import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Button from '../../components/ui/Button'
import { validateEmail } from '../../user/validate'
import { resetFeedback, sendFeedback } from './feedbackActions'
import './infoPageForms.pcss'

const FeedbackForm = () => {
  const dispatch = useDispatch()
  const loading = useSelector(state => state.feedback.get('loading'))
  const sent = useSelector(state => state.feedback.get('sent'))
  const error = useSelector(state => state.feedback.get('error'))

  const [emailValue, setEmailValue] = useState('')
  const [emailValid, setEmailValid] = useState(null)
  const [messageValue, setMessageValue] = useState('')
  const [messageValid, setMessageValid] = useState(null)

  const handleEmailChange = (e) => {
    const value = e.target.value
    const valid = value.trim() === '' || validateEmail(value) || (e.type === 'blur' ? false : null)
    setEmailValue(value)
    setEmailValid(valid)
  }

  const handleMessageChange = (e) => {
    const value = e.target.value
    const valid = value.trim().length > 5 ? true : null
    setMessageValue(value)
    setMessageValid(valid)
  }

  const handleMoreFeedbackClick = () => {
    setMessageValue('')
    setMessageValid(null)
    dispatch(resetFeedback())
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const validatedMessageValid = !!messageValid
    const validatedEmailValid = emailValid || emailValid == null // Must be valid OR EMPTY
    setMessageValid(validatedMessageValid)
    setEmailValid(validatedEmailValid)

    if (!validatedMessageValid || !validatedEmailValid || loading) {
      return
    }

    const emailBody = {
      'Viesti': messageValue,
      'Sähköposti': emailValue,
      'Selain': window?.navigator?.userAgent ?? '?',
      'Ruutukoko': window.innerWidth + '\u00d7' + window.innerHeight + 'px',
    }
    dispatch(sendFeedback(emailValue, emailBody))
  }

  if (sent) {
    return (
      <section className='info-page-form-thanks'>
        <h2>Kiitos palautteestasi!</h2>
        <p>Jos jätit sähköpostiosoitteesi, vastaamme sinulle mahdollisimman pian.</p>
        <Button type='button' onClick={ handleMoreFeedbackClick }>Anna lisää palautetta</Button>
      </section>
    )
  }

  if (error) {
    return (
      <section className='info-page-form-error'>
        <h2>Virhe!</h2>
        <p>
          Lomakkeen lähetys epäonnistui. Voit yrittää myöhemmin uudelleen tai lähettää palautetta sähköpostitse
          <a href='mailto:ampparit@ampparit.com?Subject=Ampparit%20palaute'>ampparit@ampparit.com</a>
        </p>
      </section>
    )
  }

  return (
    <form className='info-page-form info-page-form--feedback' noValidate onSubmit={ handleSubmit }>
      <div className='form-group-container'>
        <div className='form-group-label'>
          <label htmlFor='email'>Sähköposti</label><br />
          <span className='form-group-label__info'>(Ei pakollinen)</span>
        </div>
        <div className='form-group-inputs'>
          <input
            type='email'
            id='email'
            placeholder='esimerkki@esimerkki.com'
            value={ emailValue }
            onChange={ handleEmailChange }
            onInput={ handleEmailChange }
            onBlur={ handleEmailChange }
          />
          { emailValid === false && (
            <div className='form-validation-message'>Sähköpostiosoite on virheellinen</div>
          ) }
        </div>
      </div>

      <div className='form-group-container'>
        <div className='form-group-label'>
          <label htmlFor='message'>Viestisi</label>
        </div>
        <div className='form-group-inputs'>
          <textarea id='message' onChange={ handleMessageChange } value={ messageValue }></textarea>
          { messageValid === false && (
            <div className='form-validation-message'>Viesti on liian lyhyt</div>
          ) }
        </div>
      </div>

      <div className='form-group-container'>
        <div className='form-group-label'>
        </div>
        <div className='form-group-inputs'>
          <Button type='submit' loading={ loading } text='Lähetä palaute' />
        </div>
      </div>
    </form>
  )
}

export default FeedbackForm
